module.exports = __webpack_public_path__ + "static/media/picture.5f701a0c.jpg";